





























import { ConsultoresService, FiltroLogAcesso } from "@/services/consultores.service";
import Confirm from "@/shared/components/confirm.vue";
import DataTable from "@/shared/components/data-table.vue";
import PeriodoNavegavel, { IntervaloPeriodo } from "@/shared/components/periodo-navegavel.vue";
import { date, dateHoraMinuto } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { ServerPageOptions } from "@/shared/utils/datatable";
import dayjs from "dayjs";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    DataTable,
    Confirm,
    PeriodoNavegavel,
  },
  filters: { date, dateHoraMinuto },
})
export default class LogAcesso extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  promiseAcesso: Promise<any[]> | null = null;
  loading = false;
  erroPeriodo: string | null = null;
  // Espelha MaximoDiasLogAcesso do ConsultoresController: aqui evita a ida ao servidor,
  // la e a guarda de verdade.
  maxDias = 366;
  periodo: IntervaloPeriodo = {
    dataInicio: dayjs().startOf("month").format("YYYY-MM-DD"),
    dataFim: dayjs().endOf("month").format("YYYY-MM-DD"),
  };
  filtro: FiltroLogAcesso = {
    idConsultor: this.idConsultor,
    dataInicio: "",
    dataFim: "",
    offset: 0,
    limit: 100,
    order: "",
  }

  headersAcesso = [
    { value: "dia", text: "Dia" },
    { value: "acessos", text: "Acessos" },
    { value: "primeiroAcesso", text: "Primeiro acesso" },
    { value: "ultimoAcesso", text: "Último acesso" },
    { value: "ip", text: "IP" },
    { value: "clientId", text: "Client" },
    { value: "appVersion", text: "Versão" },
  ];

  onPeriodoChange(valor: IntervaloPeriodo) {
    this.periodo = valor;
    this.Pesquisar();
  }

  async Pesquisar(options?: ServerPageOptions) {
    const form = this.$refs.form as any;

    if (options == null) {
      this.filtro.offset = 0;
    }

    this.filtro.dataInicio = this.periodo.dataInicio;
    this.filtro.dataFim = this.periodo.dataFim;

    if (!form || form.validate()) {
      if (options) {
        Object.assign(this.filtro, options);
      }

      this.promiseAcesso = ConsultoresService.ListaLogAcesso(this.filtro);
    }
  }
}
